import { createSlice } from "@reduxjs/toolkit";

const general = {
  visibleBankBalance: true,
  visibleHomeBalance: true,
  pdfFile: null,
  pdfTitle: null,
  pwaConfig: null,
  assets: null,
  assetLoading: null
};

const generalSlice = createSlice({
  name: "general",
  initialState: general,
  reducers: {
    setHomeBalance: (state, action) => {
      state.visibleHomeBalance = action.payload;
    },
    setBankBalance: (state, action) => {
      state.visibleBankBalance = action.payload;
    },
    setPdfFile: (state, action) => {
      state.pdfFile = action.payload;
    },
    setPdfTitle: (state, action) => {
      state.pdfTitle = action.payload;
    },
    setPwaConfigData: (state, action) => {
      state.pwaConfig = action.payload;
    },
    setAssetsData: (state, action) => {
      state.assets = action.payload;
    },
    setAssetsLoadingData: (state, action) => {
      state.assetLoading = action.payload;
    },
  },
});

export const generalReducer = generalSlice.reducer;
export const {
  setHomeBalance,
  setBankBalance,
  setPdfFile,
  setPdfTitle,
  setPwaConfigData,
  setAssetsData,
  setAssetsLoadingData
} = generalSlice.actions;
